export const referrals = {
  menu: {
    label: "Recomienda y gana",
    badge: "Gana",
  },
  welcomeCard: {
    title: "Tu plan puede salirte gratis",
    desc: "Invita a otros anfitriones y gana una parte de todo lo que paguen, para siempre.",
  },
  page: {
    loading: "Cargando tus referidos…",
    previewNotice: "Vista previa con datos de ejemplo. Aquí aparecerán tus referidos reales cuando el programa esté activo.",
  },
  hero: {
    title: "Invita a otros anfitriones y usa WACheckin gratis",
    subtitle: "Por cada anfitrión que contrate con tu enlace, ganas el {percent}% de todo lo que pague, todos los meses y para siempre. Tu colega empieza con un {friendPercent}% de descuento.",
    personal: "Tu plan cuesta {price} al mes. Con {count} invitados como tú, no vuelves a pagar.",
    personalGeneric: "Con {count} anfitriones como tú pagando, tu plan te sale gratis.",
  },
  rewards: {
    youGet: "Tú ganas",
    youGetBig: "{percent}% de cada pago",
    youGetSmall: "de cada anfitrión que invites, todos los meses y para siempre",
    friendGets: "Tu colega gana",
    friendGetsBig: "{percent}% de descuento",
    friendGetsSmall: "sus {months} primeros meses",
    example: "Si invitas a un anfitrión con {units} apartamentos, ganas unos {amount} al año mientras siga con nosotros.",
  },
  welcomeOffer: {
    title: "Tu regalo de bienvenida",
    text: "{name} te invitó a WACheckin: tienes un {percent}% de descuento en tus {months} primeros meses. Se aplica cuando contrates tu plan.",
  },
  share: {
    title: "Tu enlace de invitación",
    codeLabel: "Tu código",
    copy: "Copiar enlace",
    copied: "Copiado",
    whatsapp: "WhatsApp",
    invite: "Enviar por email",
    more: "Más",
    message: "Te paso WACheckin: lo uso para el check-in online, los mensajes a huéspedes y conectar Booking y Airbnb, y me ahorra mucho tiempo. Con mi enlace tienes un {percent}% de descuento los {months} primeros meses: {link}",
    emailSubject: "Te regalo un {percent}% en WACheckin",
  },
  invite: {
    title: "Invita por email",
    subtitle: "Enviaremos a tu colega una invitación personal con tu enlace y su {percent}% de descuento.",
    emailLabel: "Email de tu colega",
    emailPlaceholder: "nombre@alojamiento.com",
    languageLabel: "Idioma del email",
    cancel: "Cancelar",
    send: "Enviar invitación",
    sending: "Enviando…",
    successTitle: "¡Invitación enviada!",
    successDesc: "Hemos enviado tu invitación a {email}.",
    another: "Invitar a otro colega",
    close: "Cerrar",
    errors: {
      invalidEmail: "Escribe un email válido.",
      selfInvite: "No puedes enviar la invitación a tu propio email.",
      alreadyInvited: "Ya invitaste a este email hace poco. Podrás volver a hacerlo en unos días.",
      dailyLimit: "Has llegado al límite de invitaciones de hoy. Vuelve a intentarlo mañana.",
      tooFast: "Demasiados intentos seguidos. Espera un minuto y vuelve a probar.",
      generic: "No hemos podido enviar la invitación. Inténtalo de nuevo.",
    },
  },
  message: {
    title: "Mensaje listo para compartir",
    hint: "Pégalo en tus grupos de anfitriones, foros o redes. Funciona mejor si añades una frase tuya.",
    copy: "Copiar mensaje",
  },
  how: {
    title: "Cómo funciona",
    stepLabel: "Paso {n}",
    step1Title: "Comparte tu enlace",
    step1Desc: "Por WhatsApp, email o en tus grupos de anfitriones.",
    step2Title: "Tu colega contrata con descuento",
    step2Desc: "Se registra con tu enlace y empieza con un {percent}% de descuento.",
    step3Title: "Tú ganas cada mes",
    step3Desc: "El {percent}% de cada pago va a tu crédito, para siempre. El primero cuenta a los {days} días.",
  },
  results: {
    title: "Tus resultados",
    celebrate: "Llevas {amount} ganados.",
    coverage: "Tus invitados ya cubren el {percent}% de tu plan",
    coverageFree: "Tu plan ya te sale gratis",
    coverageHint: "Tu plan cuesta {price} al mes y tus invitados te dan {earning} al mes.",
  },
  stats: {
    invited: "Invitados",
    subscribed: "Pagando",
    monthlyEarning: "Ganas al mes",
    creditAvailable: "Crédito disponible",
    creditEarned: "{amount} ganados en total",
    creditHint: "Se descuenta solo de tu próxima factura",
  },
  list: {
    title: "Tus referidos",
    colName: "Cuenta",
    colDate: "Alta",
    colStatus: "Estado",
    colReward: "Lo que ganas",
    empty: "Todavía no has invitado a nadie. El primer anfitrión que contrate con tu enlace ya te hace ganar crédito cada mes.",
  },
  status: {
    registered: "Registrado",
    subscribed: "Pagando",
    rewarded: "Ganando",
    canceled: "De baja",
    rejected: "No válido",
  },
  reward: {
    waiting: "Esperando su primer pago",
    startsOn: "Empiezas a ganar el {date}",
    earning: "{monthly} al mes, {earned} en total",
    earningNoPlan: "{earned} en total",
    canceled: "{earned} ganados",
  },
  reasons: {
    duplicate: "Cuenta duplicada",
    selfReferral: "Autorrecomendación",
  },
  faq: {
    title: "Preguntas frecuentes",
    howMuchQ: "¿Cuánto gano?",
    howMuchA: "El {percent}% de todo lo que pague cada anfitrión que invites (sin impuestos), todos los meses y para siempre, sin límite de invitados. Si paga {price} al mes, ganas unos {amount} cada mes.",
    whenQ: "¿Cuándo lo recibo?",
    whenA: "Cada vez que tu invitado paga, se suma solo a tu crédito. Su primer pago cuenta cuando pasan {days} días, por si se da de baja nada más contratar.",
    whereQ: "¿Dónde se usa el crédito?",
    whereA: "Se descuenta automáticamente de tus próximas facturas de WACheckin. Si todavía no has contratado, se aplica en tu primera factura.",
    limitQ: "¿Hay algún límite?",
    limitA: "No hay límite de invitados ni de tiempo. Lo único: el crédito que llevas ahorrado sin gastar llega como mucho a {months} meses de tu plan. Mientras estés en ese tope, tu plan sigue saliéndote gratis; lo que pase de ahí no se acumula.",
    stopQ: "¿Cuándo dejo de ganar?",
    stopA: "Si tu invitado se da de baja, dejas de ganar por él. Si te das de baja tú, dejas de acumular crédito.",
    whoQ: "¿A quién puedo invitar?",
    whoA: "A cualquier anfitrión u hotel que todavía no use WACheckin. No valen las autoinvitaciones ni las cuentas duplicadas.",
  },
};
